import {callFirebaseFunction} from 'utils/firebaseUtils'

/**
 * Creates a shared boundary using Firebase Cloud Functions
 * @param {string} userId - The user ID to share the boundary for
 * @param {string} boundaryId - The boundary ID to share
 * @returns {Promise<string>} - A promise that resolves to the shared boundary ID
 */
export const createSharedBoundary = async (userId, boundaryId) => {
    try {
        const result = await callFirebaseFunction('shareUserBoundary', { userId, boundaryId }, { debugLabel: 'createSharedBoundary' });
        return result;
    } catch (error) {
        console.error('Error creating shared boundary:', error);
        return error.message;
    }
};

/**
 * Retrieves the boundary data from a shared boundary ID
 * @param {string} sharedBoundaryId - The shared boundary ID to look up
 * @returns {Promise<object|null>} - A promise that resolves to the boundary data or null
 */
export const getSharedBoundary = async (sharedBoundaryId) => {
    try {
        // Input validation
        if (!sharedBoundaryId) {
            throw new Error('Missing required parameter: sharedBoundaryId');
        }
        
        // Call the Firebase Cloud Function
        const result = await callFirebaseFunction('getSharedBoundary', 
            { shareId: sharedBoundaryId }, 
            { debugLabel: 'getSharedBoundary' }
        );
        
        // Return the boundary data
        return result;
    } catch (error) {
        console.error(`Error retrieving shared boundary: ${error.message}`, error);
        throw new Error(`Failed to get shared boundary: ${error.message}`);
    }
};

